/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
    Dialog,
    DialogTitle,
} from '../src/components/Dialog';

function RipplesignPopUp(props) {
    const { isRipplePage } = props;
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(true);
    const [email, setEmail] = useState('');

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const mailId = window.sessionStorage.getItem('customerEmail');

        if (isRipplePage === true && mailId === null) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [isRipplePage]);

    const ValidateFields = (name, value) => {
        const emailRegx = RegExp(
            /^[a-zA-Z0-9]+(_)?([-_+.][a-zA-Z0-9_]+)*\@[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*\.[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*$/,
        );
        setEmail(value);
        if (emailRegx.test(value) === false) {
            setError(true);
        } else {
            setError(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        ValidateFields(name, value);
    };

    const handleSubmit = () => {
        if (error === false) {
            window.sessionStorage.setItem('customerEmail', email);
            // if want to add GA event it can add from here
            handleClose();
        }
    };

    return (
        <div className="homepage-popup ripplemock-home">
            <Dialog open={open} onClose={handleClose}>

                <DialogTitle className="Dialog-overlay" component="div">
                    <div className="Dialog-content">
                        {/* <img src="https://images.ctfassets.net/8g0fievzqg8k/f03oSvA31tvrFlkgfpBmq/
                        a2ea48f20e05f8958f138cdfe37ee3e9/PC_img-reviewd.png" alt="img" /> */}
                        <div className="containerone ripplepopup-singin">
                            <div align="center" className="form-labell">
                                <label>
                                    メールアドレスで認証
                                </label>
                            </div>
                            <div className="emaillabel">
                                <input
                                    className="input_field"
                                    type="email"
                                    value={email}
                                    name="email"
                                    placeholder="Enter a valid Email id"
                                    // onBlur={this.handleBlur}
                                    onChange={handleChange}
                                />
                                <div className="ripple-error">
                                    {error === true ? <p>メールアドレスをご入力ください</p> : ''}
                                </div>
                                {/* {this.state.errors.email && this.state.errors.email !== '' && (
                                    <span className="error">{this.state.errors.email}</span>
                                )} */}
                            </div>
                            <div className="ripple-tc">
                                <h3>個人情報の提供に同意し送信</h3>
                                <p>
                                    こちらは現在開発中の製品お知らせページです。ご希望のサイズや色をお選びいただいた後、
                                    「この製品が欲しい」ボタンを押していただくと、より詳細な製品情報などが入り次第ご連絡を差し上げます。お客様からいただいた個人情報は、
                                    サービスのご提供やメール等によるご案内、
                                    サンプル・プレゼント等の送付、統計的データとしての利用のために、
                                    必要な範囲でP&Gグループ企業（日本国外を含む）と共同で利用いたします*1。なお、お客様からいただいた個人情報は、
                                    その秘密が保持されるよう、P&Gグループのデータベースに保管され、ご本人の同意を得ずに外部機関に対してそれらの情報の交換・売買・共有を行うことはありません。ただし、
                                    弊社またはP&Gグループ企業は、業務代行者（日本国外を含む）へ業務遂行に必要最小限の個人情報を開示する場合があります。業務代行者は、
                                    開示された個人情報を委託した内容を超えて使用することを禁じられており、情報を適切に取り扱います。*1 共同利用の管理責任者：プロクター・アンド・ギャンブル・ジャパン合同会社
                                </p>

                            </div>

                            <div className="Ripple-cta">
                                <button
                                    type="button"
                                    className="ripple-submit"
                                    onClick={handleSubmit}
                                >送信
                                </button>
                            </div>
                        </div>

                    </div>
                </DialogTitle>
            </Dialog>
        </div>
    );
}

RipplesignPopUp.propTypes = {
    isRipplePage: PropTypes.any,
};
export default RipplesignPopUp;
